
export const WorkflowSection = () => {
  const workflowSteps = [
    {
      step: "01",
      title: "PRE-PRODUCTION",
      description: "AI finds and researches guests, prepares customized outreach, and generates interview questions based on deep research."
    },
    {
      step: "02",
      title: "RECORDING",
      description: "Access AI-generated research, talking points, and questions during interviews. Get real-time suggestions for follow-up questions."
    },
    {
      step: "03",
      title: "POST-PRODUCTION",
      description: "Automatically generate show notes, blog posts, social content, and distribution across all platforms. Track analytics and get improvement suggestions."
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl font-bold mb-4">AI-Powered Podcast Workflow</h2>
          <p className="text-muted-foreground">
            From research to publication, Agent V uses AI at every step
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {workflowSteps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-primary/10 text-primary font-bold text-2xl w-12 h-12 rounded-full flex items-center justify-center mb-4">
                {step.step}
              </div>
              <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
              <p className="text-muted-foreground">{step.description}</p>
              
              {index < 2 && (
                <div className="hidden md:block absolute top-6 left-[calc(100%-12px)] w-[calc(100%-24px)] h-px bg-border z-0"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
